import profilePic from '../Assets/Dp.jpeg';

export const BannerContent = {
  name: "Abhijith Eanuga",
  role: "Senior Systems Architect & AI Specialist",
  email: "eabhijith@gmail.com",
  location: "Berlin, Germany",
  linkedin: "https://linkedin.com/in/eabhijith",
  github: "https://github.com/eabhijith",
  website: "https://eabhijith.github.io/personal/",
  huggingface: "https://huggingface.co/eabhijith",
  displayPic: profilePic,
  professionalSummary: "Senior Systems Architect and AI Specialist with 11+ years building enterprise CRM, full-stack, and AI-native systems. Currently leading agentic orchestration, LLM system design, and AI harness engineering \u2014 multi-agent workflows with LangGraph and Google ADK, RAG pipelines, LoRA fine-tuning, and MCP-native integrations. Specialised in bridging the Salesforce platform with modern AI infrastructure, and in the unglamorous half of the job: guardrails, human-in-the-loop safety layers, and observability that keep autonomous agents trustworthy in production. 4x Salesforce Architect, AWS Cloud Practitioner, Agentforce Specialist. Lately: transformer internals, training dynamics, time-series forecasting \u2014 and an FPGA on the desk.",
};
